"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var LogoSection_1 = __importDefault(require("../LogoSection"));
var hooks_1 = require("./hooks");
var OnboardingFooter_1 = __importDefault(require("./OnboardingFooter"));
var makeStepTemplate = function (WizardContext, options) {
    var OnboardingFooter = (0, OnboardingFooter_1.default)(WizardContext, options === null || options === void 0 ? void 0 : options.footer);
    return function (_a) {
        var onSkipClick = _a.onSkipClick, isNextDisabled = _a.isNextDisabled, onBeforeNext = _a.onBeforeNext, children = _a.children;
        var trackMappedState = (0, hooks_1.useTrackMappedStep)(WizardContext, options === null || options === void 0 ? void 0 : options.trackingMap);
        return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexShrink: 1 }, { children: (0, jsx_runtime_1.jsx)(LogoSection_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexGrow: 2, position: "relative", height: "100%", overflow: "hidden" }, { children: (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, __assign({ electOldSafariFix: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ height: "100%", display: "flex", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ m: "auto", maxWidth: 475, width: "100%", py: 4 }, { children: children })) })) })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexShrink: 1 }, { children: (0, jsx_runtime_1.jsx)(OnboardingFooter, { onSkipClick: onSkipClick, isNextDisabled: isNextDisabled, onBeforeNext: onBeforeNext, trackMappedState: trackMappedState }) }))] })));
    };
};
exports.default = makeStepTemplate;
